import React from 'react';
import { FaInstagram, FaTiktok, FaYoutube } from 'react-icons/fa';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            {/* <hr className="footer-separator" /> */}
            <div className="footer-content">

                {/* Patrocionios y derechos */}
                <div className="footer-left">
                    {/* Redes sociales */}
                    <a href="https://www.youtube.com/@johnsanndra" target="_blank" rel="noopener noreferrer" className="social-icon">
                        <FaYoutube />
                    </a>
                    <a href="https://www.instagram.com/alayi_events" target="_blank" rel="noopener noreferrer" className="social-icon">
                        <FaInstagram />
                    </a>
                    <a href="https://www.tiktok.com/@john.sanndra?_t=8qXDhCdD0Dp&_r=1" target="_blank" rel="noopener noreferrer" className="social-icon">
                        <FaTiktok />
                    </a>
                    <p>
                        ¿Quieres que tu marca sea parte de nuestros eventos?
                        <a href="mailto:alayievents@gmail.com" className="footer-link"> Patrocinios y colaboraciones aquí</a>
                    </p>
                    <p>© 2024 Alayi Events | Todos los derechos reservados</p>

                </div>

            </div>
        </footer>
    );
};

export default Footer;